export default __webpack_public_path__ + "static/media/logo_healthid_g.ecd025e3.png";